import { TextInput } from "app/components/FormInputs/FormInputs";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
//
type Props = {
  deposit: (...args: Array<any>) => any;
  I18n: any;
  handleChange: (...args: Array<any>) => any;
  tab: string;
  TabTypes: Record<string, any>;
};

class BankDetailsForm extends Component<Props> {
  render(): React.ReactElement<React.ComponentProps<"form">, "form"> {
    const { deposit, I18n, handleChange, tab, TabTypes } = this.props;
    return (
      <form onSubmit={deposit}>
        <TextInput
          type="number"
          id="amount"
          label={I18n.amount}
          onChange={handleChange}
        />
        <TextInput
          type="text"
          id="comments"
          label={I18n.comments}
          onChange={handleChange}
        />
        <button id="deposit_button" type="submit">
          {tab === TabTypes.DEPOSIT && (
            <FormattedMessage tagName="span" id="cashier-deposit-button" />
          )}
          {tab === TabTypes.WITHDRAW && (
            <FormattedMessage tagName="span" id="cashier-withdraw-button" />
          )}
        </button>
      </form>
    );
  }
}

export default BankDetailsForm;
